import { GoldenDomeNotificationType } from "@redotech/redo-model/golden-dome-notifications";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const createGoldenDomeNotification = {
  name: "createGoldenDomeNotification" as const,
  input: z.object({
    appIds: z.array(z.string()),
    title: z.string(),
    customMessage: z.string().optional(),
    notificationType: createEnum(GoldenDomeNotificationType).optional(),
    includeAppInstallationRemoved: z.boolean().optional(),
  }),
  output: z.object({ id: z.string() }),
};
